import Image from 'core/display/Image'
import { signal } from 'services/SignalsService'
import { create } from 'utils/Object'

export default class PageCarousel extends PIXI.Container{
  constructor(data) {
    super()

    this.data = data

    signal.on('INIT:PAYTABLE:SLIDER', this.createSlider.bind(this))
    signal.on('PAYTABLE:PAGE', () => {
      this.dots.forEach(this.dotSelected.bind(this))
    })

  }

  createSlider(){
    this.numbers = new PIXI.Container
    this.makeImage()
    this.createDots()
  }

  createDots() {
    this.dots = game.models.PaytableModel.getList().map(this.makeData.bind(this)).map(this.makeImage.bind(this))
    this.dots.forEach(this.applyPosition.bind(this))
    this.dots.forEach(this.dotSelected.bind(this))
    this.numbers.addChild(...this.dots)
    this.addChild(this.numbers)
  }

  makeImage(){
    return new Image(this.data)
  }

  makeData(index) {
    return create(this.data, { index })
  }

  applyPosition(dots, idx) {
    dots.x = (-this.data.width + (idx * this.data.width) * 2) - 70
    dots.y = 0
    dots.id = idx
  }

  dotSelected(dot){
    dot.images[0].visible =  game.models.PaytableModel.getID() !== dot.id
    dot.images[1].visible = game.models.PaytableModel.getID() === dot.id
  }
}
